import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
let sentryDns: string = "https://40a671d469624e6afb6e268d5f1de136@sentryfrontendnew.shadowfax.in/33";
let replaysSessionSampleRate: number = 0
let replaysOnErrorSampleRate: number = 0
if (environment.production) {
  sentryDns = "https://7bdb568dfd61e64d5ed050fa69f92112@sentryfrontendnew.shadowfax.in/13";
  replaysSessionSampleRate = 0;
  replaysOnErrorSampleRate = 0;
  enableProdMode();
}
Sentry.init({
  dsn: sentryDns,
  replaysSessionSampleRate: replaysSessionSampleRate,
  replaysOnErrorSampleRate: replaysOnErrorSampleRate,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 1.0,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
